import React from "react";
import { Dialog, DialogTitle, DialogContent, Backdrop, CircularProgress, Box } from "@material-ui/core";

export const StorageTransactionDialog = ({
	open,
	onClose,
	title,
	loading,
	classes,
	form,
	results,
}) => {
	if (!open) {
		return null;
	}

	return (
		<Dialog open={true} onClose={onClose} maxWidth="xl" fullWidth classes={{ paper: classes.fullScreenDialog }}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				{form}

				<Box className={classes.resultsContainer} position="relative">
					{results}
					<Backdrop open={loading} className={classes.loadingBackdrop}>
						<CircularProgress size={60} thickness={4} />
					</Backdrop>
				</Box>
			</DialogContent>
		</Dialog>
	);
};
